export const validateFeeRanges = (text) => {
    try {
        if (!text) return true
        const json = JSON.parse(text);
        const isValidStructure = json.every(
            (item) =>
                typeof item === "object" &&
                item !== null &&
                "range" in item &&
                "value" in item &&
                typeof item.range === "string" &&
                typeof item.value === "number",
        );
        return isValidStructure;
    } catch (e) {
        return false;
    }
};
